import React from 'react'

interface BabylistStoreProps {
  className?: string
}

const BabylistStore: React.FC<BabylistStoreProps> = ({
  className,
}: BabylistStoreProps) => (
  <svg
    className={className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="10" cy="10" r="10" fill="#6E3264" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4442 6.33903C10.7389 6.66527 10.2839 7.21503 9.96823 7.88664H9.96652C9.65069 7.21503 9.19575 6.66527 8.49038 6.33903C7.36331 5.81763 6.2626 5.88884 5.25513 6.61424C4.2619 7.32949 3.88172 8.33868 4.03153 9.54936C4.22524 11.1146 5.08779 12.298 6.20893 13.3253C7.32282 14.3457 8.60485 15.1116 9.96704 15.7498H9.96757C11.3298 15.1116 12.6119 14.3457 13.7255 13.3253C14.847 12.298 15.7094 11.1146 15.9031 9.54936C16.0529 8.33868 15.6727 7.32949 14.6795 6.61424C14.1056 6.20097 13.5012 6 12.8792 6C12.4092 6 11.9292 6.11473 11.4442 6.33903Z"
      fill="url(#paint0_linear_417_362)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.11194 6.00001C7.11194 6.00001 4.69796 7.47522 5.52952 9.75509C6.36095 12.0348 9.57946 10.8011 9.57946 10.8011L9.57655 10.8001C9.57655 10.8001 12.7952 9.56638 13.6266 11.8463C13.819 12.3736 13.8376 12.8579 13.7527 13.2909L13.7545 13.2988C14.8617 12.2776 15.7109 11.1011 15.9031 9.54937C16.0529 8.33856 15.6726 7.3295 14.6793 6.61425C13.672 5.88871 12.5711 5.8175 11.4442 6.33904C10.7388 6.66528 10.2839 7.21504 9.9682 7.88678H9.96636C9.65066 7.21504 9.19572 6.66528 8.49036 6.33904C8.01853 6.1208 7.55146 6.00634 7.09387 6.00027L7.11194 6.00001Z"
      fill="#FF7AAB"
    />
    <defs>
      <linearGradient
        id="paint0_linear_417_362"
        x1="15.8796"
        y1="15.9101"
        x2="15.8796"
        y2="6.25013"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3B3F" />
        <stop offset="1" stopColor="#FF79AA" />
      </linearGradient>
    </defs>
  </svg>
)

export default BabylistStore
